import {mapQuizSessionDbToType, QuizSession, QuizSessionState} from '@cp/model';
import {limit as limitFirestore, onSnapshot, orderBy, query, where} from 'firebase/firestore';
import mapFirestoreQuerySnapshotToData from '../../helper/firebase/mapFirestoreQuerySnapshotToData';
import getQuizSessionCollection from './getQuizSessionCollection';

const DEFAULT_LIMIT = 10;

export default function subscribeQuizSessionCollectionCompleted(
  uid: string,
  onData: (sessions: QuizSession[]) => void,
  onError?: (err: Error) => void,
  limit: number = DEFAULT_LIMIT,
): () => void {
  const col = getQuizSessionCollection(uid);
  const q = query(
    col,
    where('endedAt', '!=', null),
    orderBy('endedAt', 'desc'),
    orderBy('startedAt', 'desc'),
    limitFirestore(limit),
  );
  return onSnapshot(
    q,
    (snapshot) => {
      const sessions = mapFirestoreQuerySnapshotToData(snapshot, (doc) => {
        const session = mapQuizSessionDbToType(doc);
        if (session.state !== QuizSessionState.COMPLETED) throw new Error('Session is not completed');
        return session;
      });
      onData(sessions.filter((s): s is QuizSession => s != null));
    },
    (err) => onError?.(err),
  );
}
